import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
// import { post } from '../../helpers/api_helper';

function Settings(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="8">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Settings')}</CardHeader>
              <CardBody>
                <Can i="see" this="Settings">
                  <div />
                </Can>

                <Can not i="see" this="Settings"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>

          <Can i="make" this="Users">
            <Col xxl="4">
              <div />
            </Col>
          </Can>
        </Row>
      </div>
    </div>
  );
}

Settings.defaultProps = {
  t: (x) => (x),
};

Settings.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Settings));
